import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";
import Leaderboard from "../components/leaderboard";

const Terms = () => {
    return (
        <div className="outline">
            <NavBar />
            <h1>Terms and Conditions</h1>
            <p>The site is in development, terms and conditions are fair use and don't try to break/hack the site.</p>
            <p>Since your on the page through, you get to view our in dev leaderboard:</p>
            <Leaderboard />
            <NavBarFooter />
        </div>
    )
}

export default Terms;